"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodStatusLookupEnum = void 0;
var PeriodStatusLookupEnum;
(function (PeriodStatusLookupEnum) {
    PeriodStatusLookupEnum[PeriodStatusLookupEnum["Open"] = 1] = "Open";
    PeriodStatusLookupEnum[PeriodStatusLookupEnum["Closed"] = 2] = "Closed";
})(PeriodStatusLookupEnum = exports.PeriodStatusLookupEnum || (exports.PeriodStatusLookupEnum = {}));
exports.default = PeriodStatusLookupEnum;
